"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Award, Puzzle, Zap, User, Globe, Leaf, Recycle, Handshake, Check, Link2, Activity, Shield, TrendingUp } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const whatSetsUsApart = [{
  icon: Puzzle,
  title: "Colaboración Radical",
  text: "En Kalisch Acero, el éxito no es individual. Trabajamos en ecosistemas integrados donde cada voz aporta valor al resultado final."
}, {
  icon: Zap,
  title: "Agilidad Industrial",
  text: "Nuestra cultura se basa en la rapidez de respuesta y la capacidad de adaptación ante los retos más complejos del sector acero."
}, {
  icon: User,
  title: "Enfoque en el Talento",
  text: "Invertimos en el crecimiento de nuestra gente, fomentando un ambiente de aprendizaje continuo y liderazgo participativo."
}, {
  icon: Globe,
  title: "Impacto Comunitario",
  text: "Nuestra cultura trasciende las oficinas; buscamos generar un impacto positivo en las comunidades donde operamos."
}];
const approachList = ["Innovación en procesos de acero", "Seguridad industrial proactiva", "Liderazgo transformacional", "Excelencia operativa constante"];
const approachFeatures = [{
  icon: Link2,
  title: "Ecosistema Integrado",
  text: "Fomentamos la sinergia entre departamentos para eliminar silos y optimizar la comunicación interna."
}, {
  icon: Activity,
  title: "Mentalidad de Mejora Continua",
  text: "Utilizamos metodologías ágiles para perfeccionar cada eslabón de nuestra cadena de valor."
}, {
  icon: Shield,
  title: "Cultura de Seguridad",
  text: "La integridad física de nuestro equipo es el pilar innegociable de nuestra dinámica diaria."
}, {
  icon: TrendingUp,
  title: "Escalabilidad Humana",
  text: "Desarrollamos planes de carrera que evolucionan al ritmo de nuestras ambiciones globales."
}];
const whyChooseList = ["Fomentar un ambiente de respeto y ética", "Impulsar la innovación desde cualquier nivel", "Construir relaciones sólidas basadas en confianza", "Actuar con responsabilidad social y ambiental"];
const sustainabilitySections = [{
  icon: Leaf,
  title: "Cultura de Sostenibilidad",
  intro: "Nuestros valores se alinean con prácticas que protegen el futuro:",
  list: ["Reducción de huella de carbono en operaciones", "Uso eficiente de recursos energéticos", "Conciencia ambiental en cada decisión"]
}, {
  icon: Recycle,
  title: "Economía Circular Interna",
  intro: "Promovemos procesos que cierran el ciclo:",
  list: ["Programas de reciclaje de acero y materiales", "Optimización de residuos industriales", "Cero desperdicio en oficinas corporativas"]
}, {
  icon: Zap,
  title: "Energía y Eficiencia",
  intro: "Implementamos tecnologías que respetan el entorno:",
  list: ["Infraestructura de bajo consumo energético", "Sistemas inteligentes de gestión de planta", "Innovación en logística sustentable"]
}, {
  icon: Handshake,
  title: "Ética y Compromiso Social",
  intro: "Nos regimos por principios de integridad total:",
  list: ["Diversidad, equidad e inclusión real", "Apoyo activo a fundaciones locales", "Desarrollo de talento joven en la industria"]
}];
const betterDecisionsList = ["Altamente colaborativo", "Orientado a resultados", "Socialmente responsable"];
const recyclingSteps = ["Si es necesario, recolectamos materiales ferrosos excedentes de nuestras operaciones", "o", "procesamos chatarra industrial para su reintegración productiva.", "Luego.", "Evaluamos el potencial de reutilización en proyectos comunitarios.", "o", "Gestionamos su disposición final bajo normas ambientales estrictas."];
function FadeInBlock({
  children,
  className = ""
}: {
  children: React.ReactNode;
  className?: string;
}) {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <div ref={ref} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"} ${className}`}>
      {children}
    </div>;
}
export default function Culture() {
  return;
}